import React from 'react';
import { Popover, Box, Typography, Stack } from '@mui/material';
import { DmsButton, DmsSelect, DmsDateTimeRangePicker, intl } from 'dmsbasereact';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';

export const FilterPopover = ({
    filterAnchorEl,
    handleCloseFilterPopover,
    filters,
    setFilters,
    loadingOptions,
    granularityOptions,
    handleApplyFilters,
    handleClearFilters,
    options
}) => {
    const isFilterPopoverOpen = Boolean(filterAnchorEl);
    const filterPopoverId = isFilterPopoverOpen ? 'filter-popover' : undefined;

    return (
        <Popover
            id={filterPopoverId}
            open={isFilterPopoverOpen}
            anchorEl={filterAnchorEl}
            onClose={handleCloseFilterPopover}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
            }}
            PaperProps={{
                sx: {
                    width: 400,
                    maxWidth: '90vw',
                    p: 2,
                    borderRadius: 2,
                    boxShadow: (theme) => theme.shadows[4]
                }
            }}
        >
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                <Typography variant="h6">
                    {intl.get("DispensationInsights.Filters.Title").d("Filters")}
                </Typography>

                <DmsSelect
                    key={'organization_branches'}
                    label={intl
                        .get("DispensationInsights.Filter.OrganizationBranch")
                        .d("Organization Branch")}
                    value={filters.branch}
                    url="organization_branch/all"
                    onChange={(value) =>
                        setFilters((prev) => ({ ...prev, branch: value }))
                    }
                    loading={loadingOptions}
                    fullWidth
                />

                <DmsSelect
                    key={`pharmacists-${options.pharmacists.length}`}
                    label={intl.get("Pharmacist").d("Pharmacist")}
                    value={filters.pharmacist}
                    options={options.pharmacists}
                    onChange={(value) => {
                        setFilters((prev) => ({ ...prev, pharmacist: value }))
                    }}
                    fullWidth
                />

                <DmsSelect
                    key={`batch`}
                    label={intl
                        .get("DispensationInsights.Filter.Batch")
                        .d("Batch")}
                    properties={{ label: "number" }}
                    name="number"
                    value={filters.batch}
                    url="batch/all"
                    onChange={(value) =>
                        setFilters((prev) => ({ ...prev, batch: value }))
                    }
                    loading={loadingOptions}
                    fullWidth
                />

                <DmsSelect
                    label={intl
                        .get("DispensationInsights.Filter.Granularity")
                        .d("Granularity")}
                    value={filters.granularity}
                    options={granularityOptions}
                    onChange={(value) =>
                        setFilters((prev) => ({ ...prev, granularity: value }))
                    }
                    fullWidth
                />

                <Stack spacing={1}>
                    <Typography variant="subtitle2">
                        {intl
                            .get("DispensationInsights.Filter.Period")
                            .d("Period")}
                    </Typography>
                    <DmsDateTimeRangePicker onChange={({ startDate, endDate }) => {
                        setFilters((prev) => ({
                            ...prev,
                            startDate: startDate ? startDate.toISOString() : null,
                            endDate: endDate ? endDate.toISOString() : null,
                        }));
                    }} />
                </Stack>

                <Stack direction="row" spacing={1} sx={{ mt: 2 }}>
                    <DmsButton
                        variant="primary"
                        onClick={handleApplyFilters}
                        startIcon={<FilterAltIcon fontSize="small" />}
                        fullWidth
                    >
                        {intl.get("Apply").d("Apply")}
                    </DmsButton>
                    <DmsButton
                        variant="secondary"
                        onClick={handleClearFilters}
                        startIcon={<FilterAltOffIcon fontSize="small" />}
                        fullWidth
                    >
                        {intl.get("Clear").d("Clear")}
                    </DmsButton>
                </Stack>
            </Box>
        </Popover>
    );
};
